import React from 'react';
import './index.scss';

const { createI18N } = window.IcbuIM.lib.I18N;

const I18N = createI18N({
  namespace: 'messenger'
});

export default class LandingPage extends React.Component {
  render() {
    return (
      <div className="landing-page-wrapper">
        <div className="landing-img">
          <img src="https://img.alicdn.com/tfs/TB1E84Hwj7nBKNjSZLeXXbxCFXa-320-160.png" />
          {
            this.props.updateChrome &&
            <p className="tip">
              <a href="https://www.google.com/chrome/" target="_blank">{I18N.get('pwa.chrometip')}</a>
            </p>
          }
        </div>
      </div>
    );
  }
}
